import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  intercept(request: HttpRequest<any>, newRequest: HttpHandler): Observable<HttpEvent<any>> {

    return newRequest.handle(request).pipe(catchError(err => {

      //   if 401 response returned from api, logout from application & redirect to login page.
      if (err.status === 401) {
        setTimeout(() => {
          this.authenticationService.forceCloseModal();
          this.authenticationService.logout();
          this.router.navigate(['/login']);
        }, 800);
      }

      let errorMessage = '';

      // const error = err.error.message || err.statusText;
      // return Observable.throw(error);
      if (err.error && err.error.message && err.status === 500) {

        // client-side error
        errorMessage = `Erro: ${err.error.message}`;
        if (err.error.message.includes('No connection could be made')) {
          errorMessage += `\nVerifique se o serviço APIService está ativo.`;
        }

      } else {
        // server-side error
        errorMessage = `Error Code: ${err.status}\nMessage: ${err.message}`;
      }


      return throwError(errorMessage);
    }));
  }
}
